import i18n from '@/i18n'

export const LOGIN_ERROR_MESSAGE = 'User must be logged in'

/**
 * Show error message with i18n 
 * @param {String} msg 
 * @param {String} replacedText 
 * @returns 
 */
export function errorMessage (msg, replacedText = '') {
  if (msg) {
    const result =  i18n.t(msg).replace(/#([^#]+)#/g, (match, key) => {
      return key ? replacedText : ''
    })
    return result
  }
  return i18n.t('global.somethingWentWrong')
}